import { BASE_URL } from "../utils/BaseUrl"
import httpRequest from "../utils/httpsRequest";

export const AddUser = async (payload) => {
  return await httpRequest(`https://fesprisadmintest-gnaaascaf7c8dwfu.eastus-01.azurewebsites.net/app/v1/ManageUser/Add`, "post", payload );
}
export const AddRole = async (payload) => {
  return await httpRequest(`${BASE_URL}/ManageUser/Add-Role`, "post", payload );
}

export const RemoveName = async (payload) => {
  return await httpRequest(`${BASE_URL}/ManageUser/RemoveUserName?userName=${encodeURIComponent(payload)}`, "delete" );
}
export const ChangeUserPassword = async (payload) => {
  return await httpRequest(`${BASE_URL}/ManageUser/change-password`, "post", payload );
}
export const EditProfile = async (payload) => {
  return await httpRequest(`${BASE_URL}/ManageUser/update`, "put", payload );
}